import { Link } from 'react-router-dom';
import { statsData } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[650px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20background%20with%20soft%20warm%20golden%20and%20deep%20red%20gradient%20waves%2C%20luxurious%20velvet%20theater%20curtain%20texture%2C%20subtle%20film%20grain%20overlay%2C%20dramatic%20spotlight%20effect%20from%20top%2C%20dark%20elegant%20cinema%20atmosphere%2C%20no%20text%2C%20minimalist%20composition&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="91免费在线视频"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/50 to-foreground-950/80"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
            <i className="ri-sparkling-2-line text-primary-400 text-sm"></i>
            <span className="text-xs md:text-sm text-primary-300 font-medium">每日更新 200+ 高清影片</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading leading-tight mb-4">
            蓝光画质
            <span className="text-primary-400">零缓冲</span>
            <br />
            畅享观影新体验
          </h1>

          <p className="text-sm md:text-base text-background-300/90 leading-relaxed max-w-xl mb-8">
            海量高清电影和热门电视剧实时更新，超清剧场任你选。
            专注提供稳定流畅不卡顿的观影服务，让每一帧画面都清晰动人。
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-3 mb-12">
            <Link
              to="/category/dongzuo"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
            >
              <i className="ri-play-circle-fill text-lg"></i>
              立即观影
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full border border-background-300/40 text-background-200 font-medium text-sm hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
            >
              了解更多
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-8 w-full max-w-2xl">
            {statsData.map((stat, idx) => (
              <div key={idx} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">{stat.value}</div>
                <div className="text-xs text-background-400 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}